export default "__VITE_ASSET__BEWnTCex__"